allowedOrigins = [
    "https://staging-web.edapp.com",
    "https://staging-cms.edapp.com",
    "https://staging-site.edapp.com",
    "https://web.edapp.com",
    "https://admin.edapp.com",
    "https://www.edapp.com",
    "https://engine.edapp.com",
    "https://app.safetyculture.com",
    "https://app.au.safetyculture.com",
    "https://app.eu.safetyculture.com",
    "https://sandpit-local.safetyculture.com:9000",
    "https://sandpit-app.safetyculture.com",
    "https://sctraining.edapp.com",
    "https://staging-sctraining.edapp.com",
    "https://training.safetyculture.com",
    "https://sandpit-training.safetyculture.com",
    "ionic://localhost",
    "https://localhost",
    "file://",

    # public preview training
    "https://staging-trainingpreview.edapp.com",
    "https://staging-trainingpreview.safetyculture.com",
    "https://trainingpreview.edapp.com",
    "https://trainingpreview.safetyculture.com"
] #  validate allowed origin

isValidEventOrigin = (event) =>
    return allowedOrigins.some((allowed) -> event.origin.includes(allowed))

isValidAncestor = ->
    ancestorOrigins = if location.ancestorOrigins then Object.values(location.ancestorOrigins)  else [document.referrer]
    return allowedOrigins.some((allowed) -> ancestorOrigins[0].includes(allowed) if ancestorOrigins[0]?)

getValidAncestor = -> 
    ancestorOrigins = if location.ancestorOrigins then Object.values(location.ancestorOrigins)  else [document.referrer]
    if (process.env.NODE_ENV == 'development') 
        return '*'
    if (isValidAncestor()) 
        return ancestorOrigins[0]
    return null

isValidEvent = (event) ->
    return process.env.NODE_ENV == 'development' || (isValidAncestor() &&  isValidEventOrigin(event))

module.exports = {
    isValidEventOrigin,
    isValidAncestor,
    getValidAncestor,
    isValidEvent
}
